import React from "react";

function CalenderIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      fill="none"
      viewBox="0 0 15 16"
    >
      <path
        fill="url(#paint0_linear_66_87)"
        d="M13.122 1.555h-2.355V.4H9.582v1.155h-4.74V.4H3.657v1.155h-2.37c-.32 0-.598.113-.833.338a1.09 1.09 0 00-.352.817v11.535c0 .31.117.58.352.81.235.23.513.345.833.345h11.835c.33 0 .61-.113.84-.338.23-.224.345-.497.345-.817V2.71c0-.32-.115-.592-.345-.817a1.156 1.156 0 00-.84-.338zm0 12.69H1.287v-8.07h11.835v8.07zm0-9.225H1.287V2.71h2.37v1.155h1.185V2.71h4.74v1.155h1.185V2.71h2.355v2.31z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_66_87"
          x1="2.36"
          x2="19.678"
          y1="-6.149"
          y2="-0.178"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.5" stopColor="#ADFF00"></stop>
          <stop offset="0.8" stopColor="#CF0"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default CalenderIcon;
